export default __webpack_public_path__ + "static/media/Mask-Group114.77f74641.svg";